module.exports = __webpack_public_path__ + "static/media/power-atk.a0d7f72f.png";